import { render, staticRenderFns } from "./HelpSectionsTable.vue?vue&type=template&id=4dc51373&"
import script from "./HelpSectionsTable.vue?vue&type=script&lang=js&"
export * from "./HelpSectionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports